import { render, staticRenderFns } from "./TheTabs.vue?vue&type=template&id=1fab74fa&scoped=true&"
import script from "./TheTabs.vue?vue&type=script&lang=coffee&"
export * from "./TheTabs.vue?vue&type=script&lang=coffee&"
import style0 from "./TheTabs.vue?vue&type=style&index=0&id=1fab74fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab74fa",
  null
  
)

export default component.exports